<template>
    <div class="login">
        <!-- <div class="login_head">
            <div class="login_head_left">
                    <img  src="static/picture/logo-2.png" alt="">
            </div>
        </div> -->
        <div style="width: 100%; height: 10%;  " class="head" >
            <div style="margin: 0 auto; width: 50%; height: 100%; display: flex; justify-content: space-between;">
              
                <div style="width: 100%; height: 100%; text-align: center; display: flex; flex-direction: column; justify-content: center;">
                    <div class="div_omit" style="width: 100%; letter-spacing: 10px; font-size: 1.8rem; color: #fff;" >  领导视窗    </div>
                </div>
            </div>
        </div>
        <div class="login_main" style="height: 90%; display: flex; align-items: center;">
            <div>
                <!-- <button class="nav prev">Prev</button> -->
                <el-button type="primary" icon="el-icon-d-arrow-left" circle @click="handlePrev()"></el-button>
               
                <!-- <i class="el-icon-d-arrow-right"></i> -->
            </div>
            <div class="carousel" data-gap="80">
                <figure>
                    <!-- <div class="carouselItem">
                        <div class="itemContent">1</div>
                    </div>
                    <div class="carouselItem">
                        <div class="itemContent">2</div>
                    </div>
                    <div class="carouselItem">
                        <div class="itemContent">3</div>
                    </div>
                    <div class="carouselItem">
                        <div class="itemContent">4</div>
                    </div>
                    <div class="carouselItem">
                        <div class="itemContent">5</div>
                    </div>
                    <div class="carouselItem">
                        <div class="itemContent">6</div>
                    </div>
                    <div class="carouselItem">
                        <div class="itemContent">7</div>
                    </div>
                    <div class="carouselItem">
                        <div class="itemContent">8</div>
                    </div>
                    <div class="carouselItem">
                        <div class="itemContent">9</div>
                    </div> -->

                    <div class="carouselItem" v-for="(item,index) in systemList" :key="index" @click="handleSwitch(item,index)">
                        <div class="itemContent">{{ item }}</div>
                    </div>
                    
                </figure>
            </div>
            <div>
                <!-- <button class="nav next">Next</button> -->
                <el-button type="primary" icon="el-icon-d-arrow-right" circle @click="handleNext()"></el-button>
            </div>
        </div>
        <!-- <div class="login_footer"></div> -->
    </div>
</template>

<script >
    // function  carousel() {
    //     var figure = $("figure"),
    //         nav = $("nav"),
    //         items = $(".carouselItem"),
    //         n = items.length,
    //         theta = 2 * Math.PI / n,
    //         currImage = 0;
    //     setUpCarousel(n, items.width());


    //     function setUpCarousel(n, s) {
    //         var apothem = s / (2 * Math.tan(Math.PI / n));
    //         figure.css('transformOrigin', '50% 50% ' + -apothem + 'px');
    //         items.css("padding", "40px " + $(".carousel").attr("data-gap") + "px 0");
    //         for (var i = 1; i < n; i++) {
    //             items.eq(i).css({
    //                 'transformOrigin': '50% 50% ' + -apothem + 'px',
    //                 'transform': 'rotateY(' + i * theta + 'rad)',
    //             });
    //         }
    //         rotateCarousel(currImage);
    //     }

    //     function rotateCarousel(index) {
    //         figure.css({
    //             "transform": "rotateX(0deg) rotateY(" + index * -theta + "rad)"
    //         });
    //     }
    //     $(".prev").click(() => {
    //         currImage--;
    //         rotateCarousel(currImage);
    //     })
    //     $(".next").click(() => {
    //         currImage++;
    //         rotateCarousel(currImage);
    //     })
    // }
export default {
    name: 'login',
    components: {
        
    },
    data () {
        return {
            currImage: 0,
            // systemList: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],

            systemList: ['能耗分析', '设备监控', '园区监控', '设备效率', '今日总览', '设备KPI', '参数监控' ],
        }
    },
    created() {
    },
    mounted () {
        // carousel()
        // var xdeg = 0;
        // // setInterval(function() {
        // //     xdeg = xdeg + 0.3;
        // //     $('figure').css('transform', "rotateY(" + -xdeg + "deg)");
        // // }, 20);


        var figure = $("figure"),
            nav = $("nav"),
            items = $(".carouselItem"),
            n = items.length;
            this.theta = 2 * Math.PI / n;
            // currImage = 0;
        this.setUpCarousel(n, items.width());


        $(".prev").click(() => {
            this.currImage--;
            this.rotateCarousel(this.currImage);
        })
        $(".next").click(() => {
            this.currImage++;
            console.log("第几个",this.currImage )
            this.rotateCarousel(this.currImage);
        })
    },
    methods: {
        handleSwitch(item, index) {
            console.log("handle", item, index)
        },
        setUpCarousel(n, s) {
            var figure = $("figure"),
                items = $(".carouselItem");

            // var apothem = s / (2 * Math.tan(Math.PI / n));
            var apothem = 600;
            figure.css('transformOrigin', '50% 50% ' + -apothem + 'px');
            items.css("padding", "40px " + $(".carousel").attr("data-gap") + "px 0");
            for (var i = 1; i < n; i++) {
                items.eq(i).css({
                    'transformOrigin': '50% 50% ' + -apothem + 'px',
                    'transform': 'rotateY(' + i * this.theta + 'rad)',
                });
            }
            
            this.rotateCarousel(this.currImage);
        },
        rotateCarousel(index) {
            var figure = $("figure")
            figure.css({
                "transform": "rotateX(0deg) rotateY(" + index * - this.theta + "rad)"
            });
        },

        // 上一个
        handlePrev() {
            this.currImage--;
            this.rotateCarousel(this.currImage);
        },
        // 下一个
        handleNext() {
            this.currImage++;
            console.log("第几个",this.currImage )
            this.rotateCarousel(this.currImage);
        },

        // 获取内容
        getList() {
            const { result } = res
            this.solutionList = JSON.parse(JSON.stringify(result.programmeList))  
        },
        // 路由跳转
        clickRouter(val) {
            this.$router.push({
            path: val
            });
        },
        // 详情
        handleDetail(item) {
            this.$router.push({
                path: item.path,
                query: {
                    type: item.type
                }
            });
          
        }
    }
}
</script>
<style scoped>
.login {
    width: 100%;
    height: 100%;
    background-image: url('~@/assets/bg1.png');
   
}
.login_main {
    width: 100%;
    display: flex;
}
.login_head {
    padding: 30px 60px;
}

.head {
      
      background-image: url(../assets/headNo.png);
      background-size: 100% 100%;
  }
.login_head_left {

}
/* //设置整个模块的大小,以及3D 元素距视图的距离 */
 .carousel {
            width: 100%;
            height: 600px;
            perspective: 800px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
 .carousel figure {
            margin: 0;
            width: 420px;
            transform-style: preserve-3d;
            transition: transform 0.5s;
        }
        
        .carouselItem {
            width: 100%;
            height: 350px;
            box-sizing: border-box;
            cursor: pointer;
            -webkit-box-reflect: below 20px -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, .5) 100%);
        }
        
        .itemContent {
            width: 100%;
            height: 100%;
            border: 1px solid rgba(0, 180, 220, 0.5);
            box-shadow: 0 0 4vw rgba(9, 46, 148, .3) inset;
            /* background: linear-gradient(180deg, rgba(9, 46, 148, 0.6), rgba(9, 46, 148, 0.3), rgba(9, 46, 148, 0.3), rgba(9, 46, 148, 0.6)); */
            
            
            background: linear-gradient(180deg, rgba(9, 46, 148, 0.8), rgba(9, 46, 148, 0.8), rgba(9, 46, 148, 0.8), rgba(9, 46, 148, 0.8));
            border-radius: 4px;
            /* font-size: 4rem; */

            font-size: 18px;
            font-weight: bolder;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
        }
        
        .carouselItem:not(:first-of-type) {
            position: absolute;
            left: 0;
            top: 0;
        }

</style> 
